@if (activityMode === 'table') {
    <label style="padding-left: 100px;" (click)="reflowChart()">
        {{ config.tableTitle }}
    </label>
}
@if (config && config.xAxis.categories.length) {
    <div class="float-end">
        <label>
            <input type="radio" [(ngModel)]="activityMode" value="graph" (click)="chartTypeSelected('graph')"> Graph
        </label>
        <label style="padding-left: 20px;">
            <input type="radio" [(ngModel)]="activityMode" value="table" (click)="chartTypeSelected('table')"> Table
        </label>
    </div>
}
<div [hidden]="activityMode !== 'graph' || (config && !config.xAxis.categories.length)"
     class="portfolio-analysis-chart"
     #chart
     style="height: 100%; width: 100%;"></div>
@if (config && !config.xAxis.categories.length) {
    <div style="display: flex; justify-content: center; height: 100%; align-items: center; font-size: 1vmax;"><em>No
        Data</em></div>
}
@if (config) {
    <div [hidden]="activityMode !== 'table'" style="height: 89%; width: 100%; overflow-y: auto;">
        <table class="table  table-bordered" style="text-align: right">
            <thead>
                <tr>
                    <th style="text-align: center">Tax Year</th>
                    @for (seriesItem of sortByPropType(config.series); track seriesItem) {
                        <th style="text-align: center"
                            [hidden]="config.chartType !=='totalFMV'">
                            {{ seriesItem.name }}
                        </th>
                    }
                    @if (showColumn(TotalValueNames.TOTALFMV, ['totalFMV', 'totalFMVPerSqFt', 'totalFMVPerUnit'])) {
                        <th style="text-align: center">
                            {{ getColumnTitle(TotalValueNames.TOTALFMV) }}
                        </th>
                    }
                    @if (showColumn(TotalValueNames.FMVPERSQFT, ['totalFMVPerSqFt', 'totalFMVPerUnit'])) {
                        <th style="text-align: center">
                            {{ getColumnTitle(TotalValueNames.FMVPERSQFT) }}
                        </th>
                    }
                    @if (showColumn(TotalValueNames.FMVPERUNIT, ['totalFMVPerSqFt', 'totalFMVPerUnit'])) {
                        <th style="text-align: center">
                            {{ getColumnTitle(TotalValueNames.FMVPERUNIT) }}
                        </th>
                    }
                    @if (showColumn(TotalValueNames.LANDFMV, ['landFMVPerSqFt', 'landFMVPerAcre'])) {
                        <th style="text-align: center">
                            {{ getColumnTitle(TotalValueNames.LANDFMV) }}
                        </th>
                    }
                    @if (showColumn(TotalValueNames.LANDFMVPERSQFT, ['landFMVPerSqFt', 'landFMVPerAcre'])) {
                        <th style="text-align: center">
                            {{ getColumnTitle(TotalValueNames.LANDFMVPERSQFT) }}
                        </th>
                    }
                    @if (showColumn(TotalValueNames.LANDFMVPERACRE, ['landFMVPerSqFt', 'landFMVPerAcre'])) {
                        <th style="text-align: center">
                            {{ getColumnTitle(TotalValueNames.LANDFMVPERACRE) }}
                        </th>
                    }
                    @if (showColumn(TotalValueNames.TOTALTAX, ['totalTaxesUngrouped'])) {
                        <th style="text-align: center">
                            {{ getColumnTitle(TotalValueNames.TOTALTAX) }}
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (xAxisCategory of reverseIt(config.xAxis.categories); track xAxisCategory) {
                    <tr>
                        <td style="text-align: center">{{ xAxisCategory }}</td>
                        @for (seriesItem of sortByPropType(config.series); track seriesItem) {
                            <td
                                [ngClass]="{'not-actual': false}"
                                [hidden]="config.chartType !=='totalFMV'">
                                @if (getCellValue(seriesItem, xAxisCategory)) {
                                    <span>{{ getCellValue(seriesItem, xAxisCategory)| currency:'USD':'':'1.0-0' }}</span>
                                }
                            </td>
                        }
                        @if (showColumn(TotalValueNames.TOTALFMV, ['totalFMV', 'totalFMVPerSqFt', 'totalFMVPerUnit'])) {
                            <td [ngClass]="{'not-actual': false}">
                                {{ getTotalValueForYear(xAxisCategory, TotalValueNames.TOTALFMV) | currency:'USD':'':getPrecision(TotalValueNames.TOTALFMV) }}
                            </td>
                        }
                        @if (showColumn(TotalValueNames.FMVPERSQFT, ['totalFMVPerSqFt', 'totalFMVPerUnit'])) {
                            <td [ngClass]="{'not-actual': false}">
                                {{ getTotalValueForYear(xAxisCategory, TotalValueNames.FMVPERSQFT) | currency:'USD':'symbol':getPrecision(TotalValueNames.FMVPERSQFT) }}
                            </td>
                        }
                        @if (showColumn(TotalValueNames.FMVPERUNIT, ['totalFMVPerSqFt', 'totalFMVPerUnit'])) {
                            <td [ngClass]="{'not-actual': false}">
                                {{ getTotalValueForYear(xAxisCategory, TotalValueNames.FMVPERUNIT) | currency:'USD':'symbol':getPrecision(TotalValueNames.FMVPERUNIT) }}
                            </td>
                        }
                        @if (showColumn(TotalValueNames.LANDFMV, ['landFMVPerSqFt', 'landFMVPerAcre'])) {
                            <td [ngClass]="{'not-actual': false}">
                                {{ getTotalValueForYear(xAxisCategory, TotalValueNames.LANDFMV) | currency:'USD':'':getPrecision(TotalValueNames.LANDFMV) }}
                            </td>
                        }
                        @if (showColumn(TotalValueNames.LANDFMVPERSQFT, ['landFMVPerSqFt', 'landFMVPerAcre'])) {
                            <td [ngClass]="{'not-actual': false}">
                                {{ getTotalValueForYear(xAxisCategory, TotalValueNames.LANDFMVPERSQFT) | currency:'USD':'symbol':getPrecision(TotalValueNames.LANDFMVPERSQFT) }}
                            </td>
                        }
                        @if (showColumn(TotalValueNames.LANDFMVPERACRE, ['landFMVPerSqFt', 'landFMVPerAcre'])) {
                            <td [ngClass]="{'not-actual': false}">
                                {{ getTotalValueForYear(xAxisCategory, TotalValueNames.LANDFMVPERACRE) | currency:'USD':'symbol':getPrecision(TotalValueNames.LANDFMVPERACRE) }}
                            </td>
                        }
                        @if (showColumn(TotalValueNames.TOTALTAX, ['totalTaxesUngrouped'])) {
                            <td [ngClass]="{'not-actual': false}">
                                {{ getTotalValueForYear(xAxisCategory, TotalValueNames.TOTALTAX) | currency:'USD':'symbol':getPrecision(TotalValueNames.TOTALTAX) }}
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
        <div>
            <div class="float-end">
                <span class="anchor-style"
                      [hidden]="config.loadedAllYears || (config.xAxis.categories.length >= data.taxYears.length)"
                      (click)="showAllYearsClicked.emit()">Show All Years</span>
            </div>
        </div>
    </div>
}
